<template>
  <div>
    <LoadingOverlay
        :activeSyncProps="activeSync"
        :isFullPageProps="true"
    />
    <FindPwErrorContext :errorContextProps="errorContext"/>
    <form @submit.prevent="findPassword">
      <ul>
        <li
            v-for="(field, index_i) in fields"
            :key="index_i"
            :class="field.class"
        >
          <label
              v-for="(item, index_j) in field.items"
              :key="index_j"
              :for="item.id"
              class="member_input"
          >
            <input
                :id="item.id"
                :class="item.class"
                :type="item.type"
                :autocomplete="item.autocomplete"
                :maxlength="item.maxlength"
                v-model="item.value"
                @input="item.event(item, index_i, index_j)"
                @blur="item.event(item, index_i, index_j)"
            >
            <span class="label">{{ $t(`${item.title}`) }}</span>
            <span :class="item.class === red ? 'description red' : 'hidden'">
              ※ {{ $t(`${item.description}`) }}
          </span>
          </label>
        </li>
      </ul>
    </form>
    <FindPwButton @findPassword="findPassword"/>
  </div>
</template>
<script>
import _API from "../../../api";
import LoadingOverlay from "@/components/loadingOverlay";
import FindPwErrorContext from "./findPwErrorContext.vue"
import validationMethods from '@/common/lib/validation.js';
import FindPwButton from "./findPwButton";

export default {
  name: 'FindPwBody',
  components: {
    FindPwButton,
    LoadingOverlay,
    FindPwErrorContext
  },
  data() {
    return {
      red: 'red_wrong',
      pass: false,
      activeSync: false,
      errorContext: {
        isError: false,
        context: ''
      },
      fields: [
        {
          index: 0,
          class: '',
          items: [
            {
              id: 'email',
              class: '',
              title: 'user.email',
              type: 'text',
              value: '',
              required: true,
              validation: false,
              description: 'account.email_form_mismatch',
              autocomplete: 'email',
              event: this.checkEachValidation
            }
          ]
        }
      ]
    }
  },
  watch: {
    fields: {
      deep: true,
      handler(newVal) {
        this.pass = newVal[0].items[0].validation;
      }
    }
  },
  methods: {
    ...validationMethods,
    findPassword() {
      if (this.pass) {
        this.activeSync = true;
        const userEmail = this.fields[0].items[0].value;
        return new Promise((resolve, reject) => {
          _API.ACCOUNT.sendResetPasswordViaEmail({userEmail})
              .then(({data}) => {
                if (data.isSuccess) {
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: 'alert.we_sent_temp_pw_by_email'
                  });
                  this.$router.push('/');
                } else {
                  switch (data.failedCode) {
                    case '1' :
                      //  아이디와 이메일이 일치하는 계정이 존재하지 않음, 또는 가입이 완료되지 않았음.
                      this.errorContext.context = `${this.$t('account.login_id_email_no')}`
                      break;
                    case '2' :
                      // 이메일 전송 실패
                      this.errorContext.context = `${this.$t('alert.failed_to_send_email_retry')}`
                      break;
                    case '3' :
                      // 예기치 못한 에러 발생
                      this.errorContext.context = `${this.$t('alert.unexpected_error')}`
                      break;
                    case 'M1' :
                      // 예기치 못한 에러 발생, 앱에서 가입한 환자의 계정인 경우
                      this.errorContext.context = `${this.$t('account.find_pw_in_app')}`
                      break;
                    default :
                      // 예기치 못한 에러 발생
                      this.errorContext.context = `${this.$t('alert.unexpected_error')}`
                      break;
                  }
                  this.errorContext.isError = true;
                }
                this.activeSync = false;
                resolve();
              })
              .catch(err => {
                console.log(`[sendResetPasswordViaEmail] ${err}`);
                this.activeSync = false;
                reject();
              });
        });
      } else {
        this.checkIfNotEntered();
      }
    },
    /**
     *  각 필드를 사용자가 클릭 후 떠나면 (@blur) or (@input)
     *  유효성을 체크한다.
     * @param id
     * @param value
     * @param index_i
     * @param index_j
     */
    checkEachValidation({id, value}, index_i, index_j) {
      this.errorContext.isError = false;
      this.errorContext.context = '';

      let validationCheck = false;
      switch (id) {
        case 'email' :
          validationCheck = this.checkEmailValidation(value);
          break
        case 'password' :
          validationCheck = (value !== '');
          break
        default :
          break
      }
      this.changeValidation(validationCheck, index_i, index_j);

    },
    /**
     * fields 에 index_i, index_j 에 해당하는 아이템의 유효성 상태와
     * 클래스를 변경한다. (빨강 경고 문구 표기)
     * @param validationCheck
     * @param index_i
     * @param index_j
     */
    changeValidation(validationCheck, index_i, index_j) {
      this.fields[index_i].items[index_j].class = validationCheck ? '' : this.red;
      this.fields[index_i].items[index_j].validation = validationCheck;
    },
    /**
     * validation 이 false 인 아이템 빨강 경고 표시
     */
    checkIfNotEntered() {
      this.fields.forEach((field, index_i) => {
        field.items.forEach((item, index_j) => {
          if (!item.validation) {
            this.checkEachValidation(item, index_i, index_j);
          }
        })
      })
    },
  }
}
</script>